<template>
  <div
    ref="dropdownContainer"
    class="dropdown-container flex"
    @click="toggleDropdown"
  >
    <div class="flex">
      <div>
        <fluent-icon icon="calendar-dropdown" size="20" class="date-color"/>
      </div>
      <div class="dropdown-selected date-selected" :title="fullText.length >= 10 ? fullText : ''">
        {{getDisplayText}}
      </div>
    </div>
    <div class="calendar">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="15.5"
        height="15.5"
        viewBox="0 0 15.5 7.5"
        :class="{'rotate-180': isDropdownOpen}"
      >
        <path
          id="_5a4c1064a3ce6606a5e3693ac39c5e09"
          data-name="5a4c1064a3ce6606a5e3693ac39c5e09"
          d="M11.512,8.431a.75.75,0,0,1,.976,0l7,6a.75.75,0,1,1-.976,1.139L12,9.988,5.488,15.569a.75.75,0,1,1-.976-1.139Z"
          transform="translate(19.75 15.75) rotate(180)"
          fill="#bcbcbc"
          fill-rule="evenodd"
        />
      </svg>
    </div>
    <div v-if="isOpen" class="dropdown-options bg-white dark:bg-slate-900">
      <div
        v-for="dateOption in dateOptions"
        :key="dateOption.id"
        class="dropdown-option"
        :class="{
          'selected-option':
            selectedOption && selectedOption.id === dateOption.id,
        }"
        @click="selectOption(dateOption)"
      >
        {{ dateOption.name }}
      </div>
    </div>
  </div>
</template>
    
    <script>
export default {
  props: {
    customDate: {
      type: String,
      default: '', // Initialize with an empty string
    },

    dateOptions: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Select a date range',
    },
    addMoreLabel: {
      type: String,
      default: 'Add More',
    },
    open: {
      type: Boolean,
      required: false,
    },
  },
  watch: {
    open(newVal) {
      this.isOpen = newVal;
      this.isDropdownOpen = newVal;
    },
  },
  data() {
    return {
      isOpen: false,
      selectedOption: null,
      isDropdownOpen: false,
    };
  },
  computed: {
    getDisplayText() {
      const text = this.selectedOption && this.selectedOption.name !== 'Custom Date'
        ? this.selectedOption.name
        : this.customDate || this.placeholder;

      return text.length >= 10 ? text.slice(0, 5) + '...' : text;
    },
    fullText() {
      return this.selectedOption && this.selectedOption.name !== 'Custom Date'
        ? this.selectedOption.name
        : this.customDate || this.placeholder;
    },
  },
  methods: {
    toggleDropdown(event) {
      event.stopPropagation(); // Prevents toggleDropdown from closing immediately on open
      // this.isOpen = !this.isOpen;
      this.isDropdownOpen = true;
      this.$emit('toggle');
    },
    selectOption(option) {
      console.log('Hello', option);
      this.selectedOption = option;
      this.isOpen = false;
      this.isDropdownOpen =false;
      this.$emit('input', option.value);
      this.closeDropdown();
    },
    closeDropdown() {
      this.isOpen = false;
      this.isDropdownOpen = false;
    },
    handleOutsideClick(event) {
      if (this.isOpen && !this.$refs.dropdownContainer.contains(event.target)) {
        this.closeDropdown();
      }
    },
    setDropdownNull(data) {
      console.log('Data:::', data);
      this.selectedOption = null;
    },
    resetDropdown() {
      this.selectedOption = null; // Clear selected option
      this.$emit('update:customDate', ''); // Reset custom date
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
    bus.$on('dropdown-data', this.setDropdownNull);
    bus.$on('reset-date-dropdown', this.resetDropdown); // Listen for reset event
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
    bus.$off('reset-date-dropdown', this.resetDropdown); // Cleanup event listener
  },
};
</script>
    <style scoped>
    .date-color{
      color: grey;
    }
</style>
 